import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { clearInvalidSession } from "helpers/authSession";
import useAppNavigationGuards from "hooks/useAppNavigationGuards";

const AppShell = () => {
  useAppNavigationGuards();

  useEffect(() => {
    clearInvalidSession();
  }, []);

  return <Outlet />;
};

export default AppShell;
